module.exports = __webpack_public_path__ + "img/patrol_flow_city_img.d14dcc7c.png";